import { Outlet } from 'react-router-dom'

import { BlankSlate } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { ComplaintsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'
import { useIsBecome } from 'modules/core/lib/useIsBecome'

import CollectionsBootstrap from 'modules/complaints/lib/CollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

const RootPage = () => {
  const isBecome = useIsBecome()

  const { data, loading: isPageDataLoading } = useQuery(ComplaintsRootPageDocument)

  const { moduleAvailabilities, loading: moduleAvailabilitiesLoading } = useModuleAvailabilities()

  if (moduleAvailabilitiesLoading || isPageDataLoading) {
    return <PageLoading />
  }

  const hasComplaints = isModuleAvailabilityEnabled(
    moduleAvailabilities,
    AvailableModules.complaints
  )

  const canUseComplaints = data?.complaints._policies.use.can ?? false

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => hasComplaints && canUseComplaints}>
        {isBecome ? (
          <BlankSlate
            illustration="alert"
            title={i18n.t('complaints.complaint.become_access_title')}
            description={i18n.t('complaints.complaint.become_access_description')}
          />
        ) : (
          <Outlet />
        )}
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
